import rpcjs from 'rpcjs';
import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {pageDimension} from './store';

// eslint-disable-next-line valid-jsdoc
/**
 */
function replaceAll(str, strReplace, strWith) {
    const esc = strReplace.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    const reg = new RegExp(esc, 'ig');
    return str.replace(reg, strWith);
}
// eslint-disable-next-line valid-jsdoc
/**
 */
export async function getLocation(val) {
    return new Promise(function(resolve, reject) {
        rpcjs.API.location.search_location(val).then(function(res) {
            resolve(res.map((i) => {
                let name = i.name + ', ' + i.countrycode;
                if (val && val.length > 0) {
                    name = replaceAll(
                        name,
                        val,
                        '<strong>' + val + '</strong>',
                    );
                }
                return {name, value: i.geonameid};
            }));
        }).catch(function(err) {
            reject(err);
        });
    });
};
// eslint-disable-next-line valid-jsdoc
/**
 */
export function initializeGsapAnimation(mainDiv, elementToAnimate, properties, sections) {
    console.log('abc');
    pageDimension.subscribe((value) => {
        if (value > 1.7) {
            gsap.registerPlugin(ScrollTrigger);
            const tl = gsap.timeline();

            tl.to(elementToAnimate, properties[0]).to(elementToAnimate, properties[1]);
            // tl.addLabel("myLabel", "<");
            ScrollTrigger.create({
                animation: tl,
                trigger: mainDiv,
                // start: "top center",
                // end: "bottom 30vh",
                toggleActions: 'restart none reverse none',
                scrub: 0,
                // markers: true,
                snap: 1 / (sections - 1),
            });
        } else {
            gsap.registerPlugin(ScrollTrigger);
            const tl = gsap.timeline();

            tl.to(elementToAnimate, properties[0]).to(elementToAnimate, properties[1]);
            // tl.addLabel("myLabel", "<");
            ScrollTrigger.create({
                animation: tl,
                trigger: mainDiv,
                // start: "top center",
                // end: "bottom 30vh",
                toggleActions: 'restart none reverse none',
                scrub: 0,
                // markers: true,
                snap: 1 / (10 - 1),
            });
        }
    });
}
